import type { RouteRecordRaw, Router } from 'vue-router'

const BillRequestRoutes: RouteRecordRaw = {
  path: '/registration/communications',
  children: [
    {
      path: '',
      name: 'CommunicationLinesView',
      component: () => import('./views/CommunicationLinesView.vue'),
      meta: {
        title: 'communicationLines.routeTitle',
      },
    },
    {
      path: 'create',
      name: 'CreateCommunicationLinesView',
      component: () => import('./views/CommunicationLinesUpsertView.vue'),
      meta: {
        title: 'createRequest',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:communicationLineId',
      name: 'EditCommunicationLinesView',
      component: () => import('./views/CommunicationLinesUpsertView.vue'),
      meta: {
        title: 'editRequest',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:communicationLineId',
      name: 'CommunicationLinesSingleView',
      component: () => import('./views/CommunicationLinesSingleView.vue'),
      meta: {
        title: 'viewRequest',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BillRequestRoutes)
}
